module.exports = __webpack_public_path__ + "img/fruit-lemons-190x100.20f19d14.jpg";